<div id="wrapper">
  <div class="page-overlay">
    <div class="preloader-wrap">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>

  <!-- header begin -->
  <header class="transparent scroll-light">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12" style="padding: 0px 40px; ">
          <!-- logo begin -->
          <div id="logo">
            <a routerLink="/home" routerLinkActive="active">
              <img
                class="logo cus_logo_icon"
                src="assets/images/nimi.png"
                alt=""
                width="100px"
              />
              <img
                class="logo-2"
                src="assets/images/nimi.png"
                alt=""
                width="100px"
              /><span class="cus_logo"
                >National Instructional Media Institute</span
              >
            </a>
          </div>
          <!-- logo close -->

          <!-- small button begin -->
          <span id="menu-btn" (click)="toggleOther()"></span>
          <!-- small button close -->

          <!-- mainmenu begin -->
          <nav>
            <ul id="mainmenu" class="main_menu_cls" [ngClass]="menu_cls" (click)="tests()">
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
              <li routerLink="/home" routerLinkActive="active">
                <a> Home </a>
              </li>
              <li routerLink="/about" routerLinkActive="active">
                <a> About Us</a>
              </li>

              <li routerLink="/vacancy" routerLinkActive="active">
                <a>Job Listings</a>
              </li>
              <li routerLink="/notification" routerLinkActive="active">
                <a>Notification</a>
              </li>
              <li><a href="http://nimiprojects.in/recruitment/register.php" target="_blank"> Register </a></li>
              <!-- <li><a href="http://nimiprojects.in/recruitment/register_jc.php" target="_blank"> Register JC </a></li> -->
              <li routerLink="/contact" routerLinkActive="active">
                <a> Contact</a>
              </li>
              <li>
                <a href="http://nimiprojects.in/recruitment/login.php" target="_blank"> Login </a>
              </li>
              <!-- <li>
                <a href="http://nimiprojects.in/recruitment/login_jc.php" target="_blank">Login JC </a>
              </li> -->
            </ul>
          </nav>
          <!-- mainmenu close -->
        </div>
      </div>
    </div>
  </header>
  <!-- header close -->
  <router-outlet></router-outlet>

  <!-- footer begin -->
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-md-6 sm-mb10">
          <div class="mt10">&copy; Content owned and provided by NIMI | Chennai   </div>
        </div>

        <div class="col-md-6 text-left text-md-right">
          <div class="social-icons">
            <a target="_blank" href="https://www.facebook.com/NIMIonlinelearning"><i class="fa fa-facebook fa-lg"></i></a>
            <a href="#"><i class="fa fa-twitter fa-lg"></i></a>
            <a href="#"><i class="fa fa-linkedin fa-lg"></i></a>
            <a target="_blank" href="https://www.youtube.com/c/NIMIVirtualClassroom"><i class="fa fa-google-plus fa-lg"></i></a>
            <a href="#"><i class="fa fa-rss fa-lg"></i></a>
            <!-- <a href="https://api.whatsapp.com/send?phone=919442507934&text=Hello%2C+Admin" target="_blank"><i class="fa fa-whatsapp fa-lg"></i></a> -->
            <!-- <a style="cursor: pointer;" (click)="tested()"><i class="fa fa-whatsapp fa-lg"></i></a> -->

          </div>
        </div>
      </div>
    </div>
  </footer>

  <!-- <div class="whatsapp_chat_support wcs_fixed_right wcs-show" id="example_1" *ngIf="whatsapp_bool">
    <div class="wcs_button_label">
       Post Your recruitment Related queries
     </div>
    <div class="wcs_button wcs_button_circle">
      <span class="fa fa-whatsapp"></span>
    </div>

    <div class="wcs_popup">
      <div class="wcs_popup_close">
        <span class="fa fa-close" (click)="show_need()" >
        </span>
      </div>
      <div class="wcs_popup_header">
        <strong style="color: #fff;">Need Help? </strong>
        <br>
        <div class="wcs_popup_header_description">Click one of our Help Desk representatives below | Chat with us from 10 AM to 6 PM</div>
      </div>
      <div class="wcs_popup_person_container">
        <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_img"><img src="assets/images/veera.png" alt=""></div>
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name">Veera Kumar </div>
            <div class="wcs_popup_person_description">Help Desk 1</div>
            <button [disabled]='disabled_bool' class="wcs_popup_person_status {{time_clr}}" (click)="tested()">{{var_online}}</button>
          </div>
        </div>

        <div class="wcs_popup_person" data-number="528123861273"  >
          <div class="wcs_popup_person_img"><img src="assets/images/nirmal.png" alt=""></div>
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name">Nirmal Kumar</div>
            <div class="wcs_popup_person_description">Help Desk 2</div>
            <button [disabled]='disabled_bool' class="wcs_popup_person_status {{time_clr}}" (click)="tested2()">{{var_online}}</button>
          </div>
        </div>

      </div>
    </div>
  </div> -->

  <div class="whatsapp_chat_support wcs_fixed_right wcs-show" id="example_1" *ngIf="whatsapp_bool">
    <!-- <div class="wcs_button_label">
       Post Your recruitment Related queries
     </div> -->
    <div class="wcs_button wcs_button_circle">
      <span class="fa fa-phone"></span>
    </div>

    <div class="wcs_popup">
      <div class="wcs_popup_close">
        <span class="fa fa-close" (click)="show_need()" >
        </span>
      </div>
      <div class="wcs_popup_header">
        <strong style="color: #fff;">Need Help? </strong>
        <br>
        <div class="wcs_popup_header_description"> Time: 10 AM to 5 PM (Mon-Fri)</div>
      </div>
      <div class="wcs_popup_person_container">
        <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:04422500657"> 044- 22500657 </a>  </div>
          </div>
        </div>
        <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:04422500069"> 044- 22500069 </a>  </div>
          </div>
        </div>
        <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:04422502421"> 044- 22502421 </a>   </div>
          </div>
        </div>
        
        <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:+919498087085"> 94980 87085 </a>   </div>
          </div>
        </div>
        <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:+919498069086"> 94980 69086 </a>   </div>
          </div>
        </div>
     

      </div>
    </div>
  </div>

  <div  (click)="show_main()" class="whatsapp_chat_support wcs_fixed_right" id="example_2" *ngIf="need_bool">
    <div class="wcs_button">

      <i class="fa fa-phone" aria-hidden="true"></i>
       Help Desk
   </div>
   </div>

  <!-- footer close -->

  <a href="#" id="back-to-top"></a>

  <div id="preloader">
    <div class="preloader1"></div>
  </div>
</div>

<style>
  .cus_logo {
    font-family: "Quicksand";
    font-size: 20px;
    color: #fff;
    padding: 0px 10px;
    font-weight: bolder;
  }
  .clone.smaller .cus_logo {
    color: #000;
  }
  .cus_logo_icon,
  .logo-2 {
    position: relative;
    top: 10px;
  }

  #mainmenu a{
    cursor: pointer;
  }
  #logo a:hover{
    text-decoration: none;
  }
  .sq-item:focus {
    outline:  0px !important;
}
@media only screen and (min-width: 993px){
  .scroll-light{
    background: rgba(0,0,0,0.2);
  }
}

@media only screen and (max-width: 992px){
  .scroll-light, .scroll-light .container-fluid {
    background: #fff !important;
}
.main_menu_cls.show_cls{
display: block !important;
}
.main_menu_cls.hide_cls{
display: none !important;
}
.cus_logo_icon, .logo-2{
  top: 5px;
}
.cus_logo{
  display: none;
}
}


</style>
